// 🔑 ONE FRAUD STATUS FOR THE STAFF REVIEW TAB (Jesse, 2026-10-23 — Review-tab proposal, pre-switch-on push).
// The flags banner read only the open flags ("No fraud flags detected (0 open)") while the review box below it read
// users.fraud_review_status ("Fraud review required … review each open flag above"): a file held for review with
// every flag dismissed showed both at once. Every fraud surface on the tab now reads this one status.
//
// Never "No fraud flags detected" while any flag is open, the file's fraud review is under way, or the identity check
// is flagged or on hold.

const HELD_ID = ['flagged', 'id_review_hold'];

/**
 * @param {object} user        users row (fraud_review_status, fraud_review_completed_at)
 * @param {object} fraudFlags  { open: [], dismissed: [], riskLevel }
 * @param {object} [iv]        identity_verifications row (status)
 * @returns {{ state, tone, title, blurb, openCount, dismissedCount, clear }}
 *   state: 'declined' | 'in_review' | 'id_held' | 'flags_open' | 'approved' | 'clear'
 *   tone:  'red' | 'amber' | 'green'
 */
export function fraudStaffStatus(user, fraudFlags, iv = null) {
  const open = Array.isArray(fraudFlags && fraudFlags.open) ? fraudFlags.open : [];
  const dismissed = Array.isArray(fraudFlags && fraudFlags.dismissed) ? fraudFlags.dismissed : [];
  const review = String((user && user.fraud_review_status) || '').toLowerCase();
  const idStatus = String((iv && iv.status) || '').toLowerCase();
  const n = open.length;
  const flagsWord = `${n} open flag${n === 1 ? '' : 's'}`;
  const out = (state, tone, title, blurb) => ({ state, tone, title, blurb, openCount: n, dismissedCount: dismissed.length, clear: state === 'clear' });

  if (review === 'declined') return out('declined', 'red', 'Fraud review declined', 'The file was declined at fraud review.');
  if (review === 'in_review') {
    return out('in_review', 'amber', `Fraud review in progress — file on hold (${flagsWord})`,
      n > 0 ? 'Review each open flag below, then approve or decline the file.'
        : `No flag is open (${dismissed.length} dismissed). Approve or decline to finish the review.`);
  }
  if (HELD_ID.includes(idStatus) || open.some((f) => f && f.category === 'identity')) {
    return out('id_held', 'amber', `Identity check ${idStatus === 'id_review_hold' ? 'on hold' : 'flagged'} — under review${n ? ` (${flagsWord})` : ''}`,
      'The identity check needs a staff decision before the file goes on.');
  }
  if (n > 0) {
    const level = String((fraudFlags && fraudFlags.riskLevel) || 'review');
    const title = level === 'high' ? 'HIGH fraud risk — multiple high-severity flags'
      : level === 'elevated' ? 'Elevated fraud risk — high-severity flag present'
        : 'Document inconsistencies detected';
    return out('flags_open', level === 'high' ? 'red' : 'amber', `${title} (${flagsWord})`,
      'Review each flag below. Dismiss with a reason if explained or verified accurate.');
  }
  if (review === 'approved') return out('approved', 'green', 'Fraud review complete — approved', 'No flag is open.');
  return out('clear', 'green', 'No fraud flags detected', 'Documents reconcile and metadata looks consistent.');
}
